import React, { useState, useEffect } from 'react';
import './Subscription.scss';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { addDays } from 'date-fns';
import Swal from "sweetalert2";

const Subscription = () => {
  const [duration, setDuration] = useState('Monthly');
  const [credits, setCredits] = useState(100);
  const [years, setYears] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [accepted, setAccepted] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const charges = duration === 'Monthly' ? `$ ${(years *12) * 499}` : `$ ${years * 5000}`;

    const baseURL = 
      process.env.NODE_ENV === 'production' 
        ? process.env.REACT_APP_API_URL_PROD 
        : process.env.REACT_APP_API_URL_LOCAL;

  useEffect(() => {
    if (startDate) {
      const daysToAdd = duration === 'Monthly' ? years* 365 : years * 365;
      const calculatedEndDate = addDays(startDate, daysToAdd);
      setEndDate(calculatedEndDate);
    } else {
      setEndDate(null);
    }
  }, [startDate, duration, years]);

  const handleDurationChange = (e) => {
    const selected = e.target.value;
    setDuration(selected);
    setCredits(selected === 'Monthly' ? (years *12) * 100 : years * 1200);
  };

  const handleYearChange = (e) => {
    const val = parseInt(e.target.value);
    setYears(val);
    if (duration === 'Annually') {
      setCredits(val * 1200);
    }
  };

  const handleSubmit = async () => {
    if (!accepted) {
      alert("Please accept the Terms & Conditions before proceeding.");
      return;
    }
  
    if (!startDate) {
      alert("Please select a start date.");
      return;
    }
  
    if (duration === 'Annually' && (!years || years < 1)) {
      alert("Please select a valid year.");
      return;
    }

    const payload = {
      duration,
      charges,
      years,
      startDate,
      endDate,
      credits,
      accepted,
      lastResetDate: startDate,
      planStatus: "Active"
    };

    const token = localStorage.getItem('token');

    try {
      const response = await axios.post(`${baseURL}/api/subscribe`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      Swal.fire({
        icon: 'success',
        title: response.data.message,
        confirmButtonColor: '#FCB124',
      });
      setCredits('');
      setStartDate('');
      setEndDate('');
      setAccepted(false);
      setYears('');
    } catch (err) {
      Swal.fire({
        icon: "warning",
        title: "Already have an subscription"
      });
      setStartDate('');
      setEndDate('');
      setAccepted(false);
      setYears('');
      console.error(err);
    }
  };

  const handleClose = () =>{
    setDuration('Monthly');
    setYears(1);
    setStartDate('');
    setEndDate('');
    setCredits(100);
    setAccepted('');
  }

  return (
    <>
    <div className='subsciption'>
      <h2 className="subscription-title">Subscription Plan</h2>
      <div className="subscription-container">
          <div>
            <div className="subscription-form">
              <div className="subscription-form-row">
                 <div className="form-group-s">
                  <label className="form-label">Select Year</label>
                  <select
                    style={{minWidth:'170px',height:'35px', padding:'8px 12px'}}
                    value={years}
                    onChange={handleYearChange}
                    // disabled={duration === 'Monthly'}
                    className="form-input-s"
                  >
                    <option value="1">1 Year</option>
                    <option value="2">2 Years</option>
                    <option value="3">3 Years</option>
                  </select>
                </div>

                <div className="form-group-s">
                  <label className="form-label">Subscription Duration</label>
                  <div className="duration-buttons">
                    <button
                      type="button"
                      className={duration === 'Monthly' ? 'active' : ''}
                      onClick={() => handleDurationChange({ target: { value: 'Monthly' } })}
                    >
                      Monthly
                    </button>
                    <button
                      type="button"
                      className={duration === 'Annually' ? 'active' : ''}
                      onClick={() => handleDurationChange({ target: { value: 'Annually' } })}
                    >
                      Annually
                    </button>
                  </div>
                </div>

                <div className="form-group-s">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    minDate={new Date()}
                    placeholderText="Select start date"
                    className="form-input-s"
                  />
                </div>

                <div className="form-group-s">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    selected={endDate}
                    disabled
                    placeholderText="Auto-calculated"
                    className="form-input-s"
                  />
                </div>
              </div>
              <hr style={{border: '0.001px solid #ccc', height:'400px'}}/>
              <div className="subscription-form-row" >
              <div className='form-group-s-flex'>
                  <div className="form-group-s" >
                    <label className="form-label">Subscription Charges</label>
                    <div className="form-value"><span>{duration === 'Monthly'? '$ 499': '$ 5000'}</span><span style={{fontWeight:'400', fontSize:'14px'}}>{duration === 'Monthly'? '/per month': '/per year'}</span></div>
                  </div>
                  <div className="form-group-s" style={{marginLeft:'30px'}}>
                    <label className="form-label">Total Subscription Charges</label>
                    <div className="form-value" value={charges}>{charges} <span style={{fontWeight:'400', fontSize:'14px'}}>for  {years} years</span> </div>
                  </div>
                </div>
                <div className='form-group-s-flex'>
                  <div className="form-group-s">
                    <label className="form-label">Credits</label>
                    <div className="form-value"><span>{duration === 'Monthly'? '100': '1200'}</span><span style={{fontWeight:'400', fontSize:'14px'}}>{duration === 'Monthly'? '/per month': '/per year'}</span></div>
                  </div>
                  <div className="form-group-s" style={{marginLeft:'60px'}}>
                    <label className="form-label">Total Credits</label>
                    <div className="form-value" value={credits}>{(years * 12) * 100} <span style={{fontWeight:'400', fontSize:'14px'}}>for {years} {years > 1 ? 'Years': 'Year'} </span></div>
                  </div>
                </div>
                <div className="form-group-s full-width ">
                  <label className="form-label checkbox-label" style={{display:'flex', flexDirection:'row', alignItems:'start', justifyContent: 'center'}}>
                    <input
                      type="checkbox"
                      checked={accepted}
                      onChange={() => setAccepted(!accepted)}
                    />
                    <span>
                    I hereby authorize Merkat Intellekt Technologies Private Limited to invoice me as per the subscription details mentioned above and I promise to pay the invoiced amount within the credit period.  I hereby accept to the <span onClick={()=>setOpenTermsModal(true)} style={{textDecoration:'underline', color: 'blue'}}>terms and conditions</span> and intend to be legally bound thereby.
                    </span>
                  </label>
                </div>

                <div className="btn-cancel-submit full-width button-group">
                  <button type="button" className="cancel-btn-s" onClick={handleClose}>
                    Cancel
                  </button>
                  <button type="button" className="submit-btn-s" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
                {openTermsModal && (
                  <div className='terms'>
                    <div className='terms-overlay' onClick={()=>setOpenTermsModal(false)}></div>
                      <div className='terms-popup-box'>
                      <h1>IMPORTANT TERMS</h1>

                          <h2>CREDIT</h2>
                          <h3>Credit Allocation and Use:</h3>
                          <p>
                            Credits are the unit of measure for accessing certain features and services offered by Revenuintel under this Agreement. Each Credit may be redeemed to submit a single request for a Scoop or Research related to a specified topic of interest. One Credit is consumed per request.
                          </p>
                          <h3>Monthly Issuance and Additional Purchases:</h3>
                          <p>
                            Credits are issued on a monthly basis according to the Subscription Plan selected by the Organization, with a minimum base allocation of 100 Credits per month. Additional Credits may be purchased by the Organization during the Term upon request, subject to Revenuintel’s then-current pricing.
                          </p>

                          <h3>Usage Restrictions and Expiry:</h3>
                          <p>
                          Credits may be used exclusively for the Services described herein and may not be transferred, exchanged, or applied toward other offerings unless expressly authorized by Revenuintel in writing. Unless otherwise agreed, all unused Credits shall expire at the end of each monthly billing period and will not roll over to subsequent periods. No refunds, credits, or compensation shall be provided for any expired or unused Credits.
                          </p>

                          <h3>Pro Rata Allocation and Monitoring:</h3>
                          <p>
                          Credits are allocated and applied on a pro rata basis throughout the monthly Subscription Term. Revenuintel may monitor Credit usage to ensure compliance with the terms and limitations set forth in this Agreement, including adherence to the intended use of Services.
                          </p>

                          <h3>Termination and Forfeiture:</h3>
                          <p>
                          In the event of termination or cancellation of the Subscription, any unused Credits remaining as of the effective date of termination shall be automatically forfeited. Organization acknowledges and agrees that it shall not be entitled to any refund, offset, or compensation for forfeited Credits under any circumstances.
                          </p>

                          <h2>LEAD GENERATION EXPERT SUPPORT</h2>
                          <h3>Complimentary Consulting Support:</h3>
                          <p>
                          As part of Revenuintel Subscription, the Organization shall receive complimentary <strong>Lead Generation Consulting Support</strong> for the contractual period from the Subscription Start Date. This support is designed to assist the Organization’s internal lead generation team in effectively utilizing the Revenuintel platform to maximize qualified lead acquisition.
                          </p>

                          <h3>Scope of Support Services:</h3>
                          <p>Revenuintel shall provide strategic and tactical guidance to aid the Organization in the planning and execution of lead generation campaigns across various channels. Services included under this complimentary support may include, but are not limited to:</p>
                          <ul>
                            <li>Expert guidance in defining a comprehensive Lead Generation Strategy</li>
                            <li>Assistance in building a data-driven Ideal Customer Profile (ICP) for targeted outreach</li>
                            <li>Data mining services utilizing the Revenuintel platform to identify and gather relevant contact information aligned with the ICP</li>
                            <li>Consultation on industry best practices across multiple lead generation tactics, including:</li>
                              <ul>
                                <li>Promotional landing pages</li>
                                <li>Warm calling strategies</li>
                                <li>Account-Based Marketing (ABM)</li>
                              </ul>
                          </ul>

                          <h3>Strategic Partnership Approach:</h3>
                          <p>
                          Revenuintel aims to act as a strategic partner to the Organization by helping identify and leverage real-time marketing opportunities across appropriate channels. Support is provided by experienced marketing specialists who succeeded in applying a data-driven methodology informed by proven industry expertise and have delivered optimal outcomes.
                          </p>

                          <h3>Limitations and Additional Scope:</h3>
                          <p>
                          While Revenuintel provides a robust platform and hands-on support, the complimentary consulting services are subject to defined boundaries in scope. In cases where the Organization's requirements extend beyond the standard scope described herein—such as customized campaign development, bespoke integrations, or extended consulting—such services shall be treated as out-of-scope and may be subject to additional fees. Any such additional scope shall be mutually agreed upon in writing prior to commencement.
                          </p>

                          <h3>Communication and Coordination:</h3>
                          <p>
                          Support services will be delivered through mutually agreed communication channels. The parties shall coordinate to define preferred points of contact and cadence for collaboration to ensure effective delivery of consulting services.
                          </p>

                          <h2>SUPPORT</h2>
                          <h3>Requesting Support:</h3>
                          <p>
                          Support request could be raised through designated channels as per the Subscription plan. User requests for support regarding Revenuintel platform can be processed through support@revenuintel.com  
                          </p>

                          <table className="support-table">
                            <thead>
                              <tr>
                                <th>Support Level</th>
                                <th>Description</th>
                                <th>Target to Resolution</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>L1</td>
                                <td>First response within 24 hours</td>
                                <td>24 hours</td>
                              </tr>
                              <tr>
                                <td>L2</td>
                                <td>If L1 fails, L2 resolves in next 8 hours</td>
                                <td>8 hours</td>
                              </tr>
                              <tr>
                                <td>L3</td>
                                <td>Custom request – based on estimate</td>
                                <td>Based on Estimate</td>
                              </tr>
                            </tbody>
                          </table>

                          <h3>Emergency Contact:</h3>
                          <p>Email: <a href="mailto:support@revenuintel.com">support@revenuintel.com</a></p>

                          <h2>NEW RELEASES</h2>
                          <p>Release of new features and change in product plans will be done at the sole discretion of REVENUINTEL.</p>

                          <h2>HOLIDAYS</h2>
                          <p>Support Consultants will follow Revenuintel’s Holiday Calendar.</p>

                          <h2>PERMISSION TO PROMOTION</h2>
                          <p>
                          Organization agrees to allow Revenuintel to reference its name and logo in marketing materials, on its website, and in case studies, subject to adherence to Organization’s brand guidelines and standards of brand integrity.
                          </p>

                          <h2>SUBSCRIPTION CHARGES</h2>
                          <p>Usage Billing start date will be considered from the start date mentioned in the subscription form.</p>

                          <h2>SUBSCRIPTION PAYMENT</h2>
                            <p>Organization is requested to process the invoice within 5 days from the invoice date.</p>

                          <div className="signature-block">
                            <button onClick={()=>setOpenTermsModal(false)}>Close</button>
                          </div>
                      </div>
                  </div>
                )}
              </div>

            </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Subscription;
